import "../styles/base.scss";
import React from "react";
import phone  from "./../assets/images/phone.png";
import address from "./../assets/images/address.png";
import email  from "./../assets/images/email.png";
import { FooterInfo,SystemInfo } from "../models/system";


export class Footer extends React.Component<FooterInfo & SystemInfo> {
    render(): React.ReactNode {
        return (
            <footer>
                <div>网站访问量</div>
                <div className="vinumber">{this.props.hit!}</div>
                <div className="f1">
                    <a href="">相关链接</a>
                    <a href="">版权声明</a>
                    <a href="/views/ContactUs">联系我们</a>
                </div>
                <div className="icp"> {this.props.cpno?.split(";")?.join(" | ")} | {this.props.copyright} {this.props.title}</div>
                <div className="address">
                    COPYRIGHT@2022 江苏中古历保建筑有限公司提供
                </div>
                {/* <div className="address">
                    <div><img src={phone} alt=""></img><span>{this.props.phone}</span></div>
                    <div><img src={address} alt=""></img><span>{this.props.address}</span></div>
                    <div><img src={email} alt=""></img><span>{this.props.zipcode}</span></div>
                </div> */}
            </footer>
        )
    }
}